import { render, staticRenderFns } from "./DigitFlip.vue?vue&type=template&id=16c56070&scoped=true"
import script from "./DigitFlip.vue?vue&type=script&lang=js"
export * from "./DigitFlip.vue?vue&type=script&lang=js"
import style0 from "./DigitFlip.vue?vue&type=style&index=0&id=16c56070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c56070",
  null
  
)

export default component.exports